export const LIVE__ON_LEVELUP_EVENT = 'LIVE__ON_LEVELUP_EVENT';
export const LIVE__ON_LEVELUP_EVENT_ERROR = 'LIVE__ON_LEVELUP_EVENT_ERROR';
